import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { openFile, byteSize, Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './supplements.reducer';

export const Supplements = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search)
  );

  const supplementsList = useAppSelector(state => state.supplements.entities);
  const loading = useAppSelector(state => state.supplements.loading);
  const totalItems = useAppSelector(state => state.supplements.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    } else {
      return order === ASC ? faSortUp : faSortDown;
    }
  };

  return (
    <div>
      <h2 id="supplements-heading" data-cy="SupplementsHeading">
        <Translate contentKey="fitengineerBackendV2App.supplements.home.title">Supplements</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="fitengineerBackendV2App.supplements.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/supplements/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="fitengineerBackendV2App.supplements.home.createLabel">Create new Supplements</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {supplementsList && supplementsList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.name">Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name')} />
                </th>
                <th className="hand" onClick={sort('quantity')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.quantity">Quantity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('quantity')} />
                </th>
                <th className="hand" onClick={sort('image')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.image">Image</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('image')} />
                </th>
                <th className="hand" onClick={sort('flavour')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.flavour">Flavour</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('flavour')} />
                </th>
                <th className="hand" onClick={sort('suitedFor')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.suitedFor">Suited For</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suitedFor')} />
                </th>
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.description">Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('description')} />
                </th>
                <th className="hand" onClick={sort('image2')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.image2">Image 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('image2')} />
                </th>
                <th className="hand" onClick={sort('image3')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.image3">Image 3</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('image3')} />
                </th>
                <th className="hand" onClick={sort('isAvailable')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.isAvailable">Is Available</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('isAvailable')} />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="fitengineerBackendV2App.supplements.price">Price</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('price')} />
                </th>
                <th>
                  <Translate contentKey="fitengineerBackendV2App.supplements.category">Category</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {supplementsList.map((supplements, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/supplements/${supplements.id}`} color="link" size="sm">
                      {supplements.id}
                    </Button>
                  </td>
                  <td>{supplements.name}</td>
                  <td>{supplements.quantity}</td>
                  <td>
                    {supplements.image ? (
                      <div>
                        {supplements.imageContentType ? (
                          <a onClick={openFile(supplements.imageContentType, supplements.image)}>
                            <img src={`data:${supplements.imageContentType};base64,${supplements.image}`} style={{ maxHeight: '30px' }} />
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {supplements.imageContentType}, {byteSize(supplements.image)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>{supplements.flavour}</td>
                  <td>{supplements.suitedFor}</td>
                  <td>{supplements.description}</td>
                  <td>
                    {supplements.image2 ? (
                      <div>
                        {supplements.image2ContentType ? (
                          <a onClick={openFile(supplements.image2ContentType, supplements.image2)}>
                            <img src={`data:${supplements.image2ContentType};base64,${supplements.image2}`} style={{ maxHeight: '30px' }} />
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {supplements.image2ContentType}, {byteSize(supplements.image2)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>
                    {supplements.image3 ? (
                      <div>
                        {supplements.image3ContentType ? (
                          <a onClick={openFile(supplements.image3ContentType, supplements.image3)}>
                            <img src={`data:${supplements.image3ContentType};base64,${supplements.image3}`} style={{ maxHeight: '30px' }} />
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {supplements.image3ContentType}, {byteSize(supplements.image3)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>{supplements.isAvailable ? 'true' : 'false'}</td>
                  <td>{supplements.price}</td>
                  <td>
                    {supplements.category ? (
                      <Link to={`/supplement-categories/${supplements.category.id}`}>{supplements.category.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/supplements/${supplements.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/supplements/${supplements.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/supplements/${supplements.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fitengineerBackendV2App.supplements.home.notFound">No Supplements found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={supplementsList && supplementsList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Supplements;
